import { useMutation } from '@apollo/client';
import {
  UPDATE_INTEGRATION_EVENTS_V2_MUTATION,
  UPDATE_INTEGRATION_CONSENT_MODE_V2_MUTATION,
  UPDATE_INTEGRATION_SMART_QUALIFY_V2_MUTATION,
  UPDATE_CREDENTIALS_MUTATION
} from '@/mutations/integrations';
import { INTEGRATION_V2_QUERY } from '@/queries/integration';

interface IntegrationUpdaterProps {
  id: string;
  customEvents: string[];
  consentMode: boolean;
  smartQualify?: boolean;
  credentials?: Record<string, any>;
}

export const useIntegrationUpdater = () => {
  const [updateIntegrationEvents] = useMutation(UPDATE_INTEGRATION_EVENTS_V2_MUTATION);
  const [updateIntegrationConsentMode] = useMutation(UPDATE_INTEGRATION_CONSENT_MODE_V2_MUTATION);
  const [updateIntegrationSmartQualify] = useMutation(UPDATE_INTEGRATION_SMART_QUALIFY_V2_MUTATION);
  const [updateCredentials] = useMutation(UPDATE_CREDENTIALS_MUTATION);

  const updateIntegration = async ({
    id,
    customEvents,
    consentMode,
    smartQualify,
    credentials
  }: IntegrationUpdaterProps) => {
    let credentialsResult;
    if (credentials) {
      credentialsResult = await updateCredentials({
        variables: {
          id,
          credentials
        },
        refetchQueries: [{ query: INTEGRATION_V2_QUERY, variables: { id } }]
      });
    }

    await updateIntegrationEvents({
      variables: { id, events: customEvents },
      refetchQueries: [{ query: INTEGRATION_V2_QUERY, variables: { id } }]
    });

    await updateIntegrationConsentMode({
      variables: { id, consentMode },
      refetchQueries: [{ query: INTEGRATION_V2_QUERY, variables: { id } }]
    });

    if (smartQualify !== undefined) {
      await updateIntegrationSmartQualify({
        variables: { id, smartQualify },
        refetchQueries: [{ query: INTEGRATION_V2_QUERY, variables: { id } }]
      });
    }

    return credentialsResult;
  };

  return { updateIntegration };
};
